import React, { useEffect, useRef } from 'react';
import { useAuth } from '../hooks/useAuth';
import { cookieAuth } from '../utils/cookieAuth';
import Loading from './Loading';

interface AuthProviderProps {
  children: React.ReactNode;
}

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const { refreshUserInfo, isLoading } = useAuth();
  const hasInitialized = useRef(false);
  const lastValidationTime = useRef(0);
  const VALIDATION_COOLDOWN = 5 * 60 * 1000; // 5분 쿨다운


  useEffect(() => {
    // 앱 시작 시 토큰 유효성 확인 (한 번만 실행)
    const initAuth = async () => {
      // 이미 초기화되었으면 중복 실행 방지
      if (hasInitialized.current) {
        return;
      }

      try {
        hasInitialized.current = true;

        // 쿠키에 사용자 정보가 있는지 확인
        const storedData = cookieAuth.getUserInfo();

        if (storedData && storedData.userInfo && storedData.userType) {
          // 마지막 검증 시간 확인 (쿨다운 적용)
          const now = Date.now();
          if (now - lastValidationTime.current < VALIDATION_COOLDOWN) {
            return;
          }

          lastValidationTime.current = now;
          await refreshUserInfo();
        } else {
        }
      } catch (error) {
        // 실패해도 사용자에게는 보이지 않게 처리
      }
    };

    initAuth();
  }, []); // 빈 의존성 배열로 앱 시작 시 한 번만 실행

  // 로딩 중일 때 전체 화면 로딩 표시
  if (isLoading) {
    return <Loading fullScreen={true} message="인증 확인 중..." />;
  }

  return <>{children}</>;
};

export default AuthProvider;